/* eslint-disable */
// https://webpack.js.org/guides/public-path/#on-the-fly

// @ts-expect-error
__webpack_public_path__ = `${__slab.BUILD_HOST}/bundles/`;
